import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	setProjectBackgroundMenuItem: {
		id: 'business-theme-components.theme-picker-button-item.set-project-background-menu-item',
		defaultMessage: 'Set project background',
		description: 'The label for the menu item that opens the background picker',
	},
});
